import React, { useMemo } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { PIPELINE_STEPS, PIPELINE_STATUSES } from '../../constants/importConstants';

const STATUS_ORDER = PIPELINE_STEPS.map((s) => s.key);

const getStepIndex = (status) => {
  if (!status) return -1;
  const idx = STATUS_ORDER.indexOf(status);
  if (idx >= 0) return idx;
  if (status === PIPELINE_STATUSES.COMPLETE || status === PIPELINE_STATUSES.PARTIAL_COMPLETE) return STATUS_ORDER.length;
  if (status === PIPELINE_STATUSES.RULES_APPLIED) return STATUS_ORDER.indexOf(PIPELINE_STATUSES.STAGING) + 0.5;
  if (status === PIPELINE_STATUSES.INGESTING || status === PIPELINE_STATUSES.CREATED) {
    return STATUS_ORDER.indexOf(PIPELINE_STATUSES.STAGING);
  }
  if (status === PIPELINE_STATUSES.NEEDS_USER_CLASSIFICATION) return STATUS_ORDER.indexOf(PIPELINE_STATUSES.CLASSIFYING);
  return -1;
};

const PipelineProgress = ({ status }) => {
  const currentIndex = useMemo(() => getStepIndex(status), [status]);

  return (
    <div className='flex items-center gap-1 px-4 py-3 bg-card rounded-lg border border-border overflow-x-auto'>
      {PIPELINE_STEPS.map((step, i) => {
        const isComplete = currentIndex > i;
        const isCurrent = Math.floor(currentIndex) === i && !isComplete;
        const isFailed = status === PIPELINE_STATUSES.FAILED && isCurrent;

        return (
          <React.Fragment key={step.key}>
            {i > 0 && (
              <div
                className={`flex-1 h-0.5 min-w-[20px] transition-colors ${
                  isComplete ? 'bg-primary' : 'bg-border'
                }`}
              />
            )}
            <div className='flex flex-col items-center gap-1 min-w-[60px]'>
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-medium transition-colors ${
                  isComplete
                    ? 'bg-primary text-primary-foreground'
                    : isCurrent
                      ? isFailed
                        ? 'bg-danger text-white'
                        : 'bg-primary/20 text-primary border-2 border-primary'
                      : 'bg-muted text-muted-foreground'
                }`}
              >
                {isComplete ? (
                  <Check size={14} strokeWidth={2} />
                ) : isCurrent && !isFailed ? (
                  <Loader2 size={14} className='animate-spin' strokeWidth={2} />
                ) : (
                  i + 1
                )}
              </div>
              <span
                className={`text-xs font-medium whitespace-nowrap ${
                  isCurrent ? 'text-primary' : isComplete ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {step.label}
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PipelineProgress;
